/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_SpeakersInputs */



/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Editor_Table_Column_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_speakers = /** @type {((inputs?: Editor_Table_Column_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Relatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Докладчики")
	if (locale === "es") return /** @type {LocalizedString} */ ("Oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palestrantes")
	return /** @type {LocalizedString} */ ("Speakers")
});